export default __webpack_public_path__ + "static/media/17.9c3a4d61.png";